import { DIRECTIONS, directionToString } from '../constant';
import { PlayerColor, playerColorToString } from '../types';

const checkWinner = (
  board: PlayerColor[][],
  row: number,
  col: number,
  color: PlayerColor
): boolean => {
  // console.log(`checkWiner called with row: ${row}, col: ${col}, color: ${playerColorToString(color)}`);
  if (!color) {
    console.log(`>Return false as color is null/undefined`);
    return false;
  }

  for (const direction of DIRECTIONS) {
    let count = 1;
    const dr = direction.at(0)!;
    const dc = direction.at(1)!;

    for (let dir = -1; dir <= 1; dir += 2) {
      let r = row + dr * dir;
      let c = col + dc * dir;

      while (
        r >= 0 && r < board.length &&
        c >= 0 && c < board.length &&
        board[r][c] === color
      ) {
        count++;
        r += dr * dir;
        c += dc * dir;
      }
    }

    if (count >= 5) {
      console.log(`>Return true for direction row: ${directionToString(direction)}`);
      return true;
    };
  }

  console.log(`>Return false as no winner exists yet`);
  return false;
};

export default checkWinner;
